// extracted by mini-css-extract-plugin
export default {"container":"Card_container__En4IL","header":"Card_header__3JofU","main":"Card_main__7WD5E"};